export const CURRENCY_AMOUNT_INPUT_NAME = 'amount'
